import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { ProfileGuard } from './guards/auth-profile.guard';
import { WithoutSidebarComponent } from './layouts/withoutSidebar/without-sidebar/without-sidebar.component';
import { AdminClientsComponent } from './admin/component/admin-clients/admin-clients.component';
import { TarjetaComponent } from './components/tarjeta/tarjeta.component';
import { BlankCardComponent } from './layouts/blank-card/blank-card.component';
import { AdminProfilesComponent } from './admin/component/admin-profiles/admin-profiles.component';
import { AdminCardComponent } from './admin/component/admin-card/admin-card.component';
import { DowloadContactComponent } from './components/dowload-contact/dowload-contact.component';
import { ClientPublicNetworkComponent } from './client/components/client-public-network/client-public-network.component';

export const routes: Routes = [
  {
    path: 'verify-qr/:code',
    loadComponent: () =>
      import('./pages/verify-qr/verify-qr.component').then(
        (m) => m.VerifyQrComponent
      ),
  },
  {
    path: 'login',
    redirectTo: 'authentication/login',
    pathMatch: 'full',
  },
  {
    path: 'register',
    redirectTo: 'authentication/register',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullComponent,
    children: [

      {
        path: '',
        redirectTo: '/admin',
        pathMatch: 'full',
      },
      {
        path: 'admin',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'client',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./client/client.module').then((m) => m.ClientModule),
      },
      {
        path: 'store',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./store/store.module').then((m) => m.StoreModule),
      },
      {
        path: 'club',
        canActivate: [ProfileGuard],
        loadChildren: () =>
          import('./club/club.module').then((m) => m.ClubModule),
      },
      {
        path: 'ficha-motor-admin',
        canActivate: [ProfileGuard],
        loadComponent: () => import('./admin/component/ficha-motor-admin/ficha-motor-admin.component').then(m => m.FichaMotorAdminComponent),
      },
      {
        path: 'admin-client/:id',
        canActivate: [ProfileGuard],
        component: AdminClientsComponent,
      },
      {
        path: 'admin-client/:icliente/profile',
        redirectTo: 'admin-client/:icliente/profile/0',
        pathMatch: 'full',
      },
      {
        path: 'admin-client/:icliente/profile/:id',
        canActivate: [ProfileGuard],
        component: AdminProfilesComponent,
      },
      {
        path: 'admin-client/:icliente/card',
        redirectTo: 'admin-client/:icliente/card/0',
        pathMatch: 'full',
      },
      {
        path: 'admin-client/:icliente/card/:id',
        canActivate: [ProfileGuard],
        component: AdminCardComponent,
      },
      {
        path: 'admin-client/:icliente/ficha-motor/:id',
        canActivate: [ProfileGuard],
        loadComponent: () => import('./admin/component/admin-ficha-motor/admin-ficha-motor.component').then(m => m.AdminFichaMotorComponent),
      }
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
      {
        path: 'giftcard/public/:uuid',
        loadComponent: () => import('./pages/giftcard/public-giftcard/public-giftcard.component').then(m => m.PublicGiftcardComponent)
      }
    ],
  },
  {
    path: '',
    component: WithoutSidebarComponent,
    children: [

      {
        path: 'public/client/:icliente/network',
        component: ClientPublicNetworkComponent,
        pathMatch: 'full',
      },
      {
        path: 'client/beneficios-only',
        loadComponent: () => import('./client/components/beneficios-client/beneficios-client.component').then(m => m.BeneficiosClientComponent),
        canActivate: [ProfileGuard],
      },
    ],
  },

  {
    path: '',
    component: BlankCardComponent,
    children: [
      {
        path: 'dltarjeta/:id',
        component: DowloadContactComponent,
      },
      {
        path: 'tarjeta/:id',
        component: TarjetaComponent,
      }
    ],
  }
];
